import style from './style.module.scss';
export function NavigateLink(props: { text: string; onClick: () => void }) {
    return (
        <span className={style.backButtonLink} onClick={props.onClick}>
            {props.text}
        </span>
    );
}
